import React from 'react';
import { Link } from 'react-router-dom';

function EulaPage() {
  return (
    <div className="agento-page">
      <nav className="agento-nav">
        <div className="agento-nav-inner">
          <Link to="/" className="agento-nav-brand">ZitotronTech</Link>
          <div className="agento-nav-links">
            <Link to="/agento">Agento</Link>
          </div>
        </div>
      </nav>

      <div className="legal-page">
        <div className="legal-content">
          <h1>End User License Agreement</h1>
          <p className="legal-effective">Effective Date: March 15, 2026</p>

          <p>
            This End User License Agreement ("EULA") is a legal agreement between you ("User",
            "you", or "your") and Zito Tron Tech LLC ("Company", "we", "us", or "our") for
            the use of the Agento software application ("Software"). By installing, copying,
            or otherwise using the Software, you agree to be bound by the terms of this EULA.
          </p>

          <h2>1. License Grant</h2>
          <p>
            Subject to the terms of this EULA and your active subscription, the Company grants
            you a limited, non-exclusive, non-transferable, revocable license to install and
            use the Software for the duration of your subscription term. This license is for
            your personal or internal business use only.
          </p>

          <h2>2. Device Limit</h2>
          <p>
            Each license permits installation and activation of the Software on a maximum of
            two (2) devices simultaneously. If you need to use the Software on additional
            devices, you must purchase additional licenses. You may deactivate a device and
            activate a new one at any time through your account settings.
          </p>

          <h2>3. Restrictions</h2>
          <p>You may not:</p>
          <ul>
            <li>Copy, modify, or distribute the Software or any portion thereof.</li>
            <li>Reverse engineer, decompile, disassemble, or otherwise attempt to derive the source code of the Software.</li>
            <li>Rent, lease, lend, sell, sublicense, or transfer the Software or your license key to any third party.</li>
            <li>Remove, alter, or obscure any proprietary notices, labels, or marks on the Software.</li>
            <li>Use the Software to develop a competing product or service.</li>
            <li>Circumvent or attempt to circumvent any license verification or activation mechanisms.</li>
          </ul>

          <h2>4. Subscription and Auto-Renewal</h2>
          <p>
            The Software is licensed on a subscription basis. Your subscription will
            automatically renew at the end of each billing period (monthly or yearly,
            depending on the plan you selected) unless you cancel before the renewal date.
            Payment is processed through Stripe. You authorize recurring charges to your
            payment method on file.
          </p>

          <h2>5. Cancellation</h2>
          <p>
            You may cancel your subscription at any time through your account portal or by
            contacting support@zitotrontech.com. Cancellation takes effect at the end of
            the current billing period. You will retain access to the Software until the
            end of the period you have already paid for. No partial refunds are issued for
            unused time within a billing period, except as provided in our refund policy.
          </p>

          <h2>6. Updates and Modifications</h2>
          <p>
            The Company may release updates, patches, or new versions of the Software from
            time to time. While your subscription is active, you are entitled to receive all
            updates at no additional charge. The Company reserves the right to modify the
            Software's features and functionality.
          </p>

          <h2>7. Intellectual Property</h2>
          <p>
            The Software and all copies thereof are the intellectual property of and are
            owned by Zito Tron Tech LLC. The structure, organization, and source code of the
            Software are trade secrets and confidential information. This EULA does not grant
            you any rights to trademarks or service marks of the Company.
          </p>

          <h2>8. Disclaimer of Warranties</h2>
          <p>
            The Software is provided "as is" without warranty of any kind, express or implied,
            including but not limited to the warranties of merchantability, fitness for a
            particular purpose, and non-infringement. The Company does not warrant that the
            Software will be uninterrupted, error-free, or free of harmful components.
          </p>

          <h2>9. Limitation of Liability</h2>
          <p>
            In no event shall the Company be liable for any indirect, incidental, special,
            consequential, or punitive damages, including without limitation, loss of profits,
            data, use, goodwill, or other intangible losses, resulting from your access to or
            use of or inability to access or use the Software. The Company's total liability
            shall not exceed the amounts paid by you for the Software in the twelve (12) months
            preceding the claim.
          </p>

          <h2>10. Termination</h2>
          <p>
            This EULA is effective until terminated. The Company may terminate this EULA
            immediately if you fail to comply with any term. Upon termination, you must
            cease all use of the Software and destroy all copies in your possession. Sections
            regarding intellectual property, limitation of liability, and governing law
            survive termination.
          </p>

          <h2>11. Governing Law</h2>
          <p>
            This EULA shall be governed by and construed in accordance with the laws of the
            State of Delaware, United States, without regard to its conflict of law provisions.
            Any legal action or proceeding arising under this EULA shall be brought exclusively
            in the courts located in Delaware.
          </p>

          <h2>12. Contact</h2>
          <p>
            If you have questions about this EULA, please contact us at:
          </p>
          <p>
            Zito Tron Tech LLC<br />
            Email: support@zitotrontech.com
          </p>
        </div>
      </div>

      <footer className="agento-footer">
        <div className="container">
          <div className="agento-footer-content">
            <p>&copy; 2026 Zito Tron Tech LLC. All rights reserved.</p>
            <div className="agento-footer-links">
              <Link to="/terms">Terms</Link>
              <Link to="/privacy">Privacy</Link>
              <Link to="/agento/eula">EULA</Link>
              <a href="mailto:support@zitotrontech.com">support@zitotrontech.com</a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default EulaPage;
